import React, {useState} from "react";
import {setSimulateurObject} from "../../../actions/simulateur.action";
import {useDispatch} from 'react-redux';
import {styles} from "../../../stylesheets/simulateurs.css";
import TextSimulateurTitle from "../../../components/texts/text.simulateurTitle";
import ButtonYesno from "../../../components/buttons/button.yesno";
import TextfieldNumber from "../../../components/textfields/textfield.number";
import SelectDepartement from "../../../components/selects/select.departement";
import TextfieldRemarques from "../../../components/textfields/textfiel.remarques";
import DeboursQuestion from "../../../components/questions/DeboursQuestion";
import LcbFtQuestion from "../../../components/questions/LcbFtQuestion";
import ConventionHonoraires from "../../../components/questions/ConventionHonoraires";

// simulateur Id 67


function Simulateur_ASF7(props) {
    const dispatch = useDispatch();

    let currUser = JSON.parse(localStorage.getItem("user"));
    let currUserDep = 0
    if (currUser.societe_zip.startsWith("97")){
        let trimedZip;
        trimedZip = currUser.societe_zip.slice(0, 3);
        currUserDep = parseInt(trimedZip)
    } else {
        let trimedZip;
        trimedZip = currUser.societe_zip.slice(0, 2);
        currUserDep = parseInt(trimedZip)
    }

    const [departement, setDepartement] = useState(0)
    const [etat_civil, setEtatCivil] = useState(0)
    const [comedec, setComedec] = useState(0)
    const [nombre_comedec_2, setComedec2] = useState(0)
    const [nombre_comedec_1, setComedec1] = useState(0)
    const [nombre_copie_authentique, setCopieAuthentique] = useState(0)
    const [nombre_copie_libre, setCopieLibre] = useState(0)
    const [nombre_archivage, setArchivage] = useState(0)
    const [montantDeboursAdditionnels, setMontantDeboursAdditionnels] = useState(0);
    const [deboursAdditionnels, setDeboursAdditionnels] = useState(0);
    const [formaliteArt204, setFormaliteArt204] = useState(0);

    const handleChange = async (setter, value, key) => {
        if (setter === setDepartement) {
            setDepartement(parseInt(value))
        } else setter(value);
        setInRedux(setter, value, key)
    };

    const handleChangeRemarque = async (value) => {
        localStorage.setItem("remarque", value)
    }

    function setInRedux(setter, value, key) {
        if (props.isParent) {

            let object = {
                simulateurid: props.simulateur.id,
                departementid: parseInt(departement),
                inputs: {
                    'etat_civil': parseInt(etat_civil),
                    'comedec': parseInt(comedec),
                    'nombre_comedec_2': parseInt(nombre_comedec_2),
                    'nombre_comedec_1': parseInt(nombre_comedec_1),
                    'nombre_copie_authentique': parseInt(nombre_copie_authentique),
                    'nombre_copie_libre': parseInt(nombre_copie_libre),
                    'nombre_archivage': parseInt(nombre_archivage),
                    'montant_deb_add': parseInt(montantDeboursAdditionnels),
                    'debours_additionnels': parseInt(deboursAdditionnels),
                    'formalite_art_204': parseInt(formaliteArt204) || 0,
                    convention_honoraires : parseInt(props.conventionHonoraires),
                },
                pdfInputs: {
                    nombre_convention_honoraires : parseInt(props.nombreConventionHonoraires),
                    object_convention_honoraires : props.objectConventionHonoraires,
                    montant_convention_honoraires : parseInt(props.montantConventionHonoraires),
                    nom_signataire_convention_honoraires : props.nomSignataireConventionHonoraires,
                    adresse_signataire_convention_honoraires : props.adresseSignataireConventionHonoraires,
                },
            };
            //For values coming from components
            if (key) {
                if (key === "debours_additionnels") {
                if (value === 0) {
                    setMontantDeboursAdditionnels(0)
                    Object.assign(object["inputs"], { montant_deb_add: parseInt(0) });
                }
                Object.assign(object["inputs"], { debours_additionnels: parseInt(value) });
                }
                if (key === "montant_deb_add") {
                Object.assign(object["inputs"], { montant_deb_add: parseInt(value) });
                }
                if (key === "formalite_art_204") {
                  Object.assign(object["inputs"], { formalite_art_204: parseInt(value) || 0 });
                }
            }
            //For internal settings
            if (setter === setDepartement) {
                object.departementid = parseInt(value)
            }

            if (setter === setEtatCivil) {
                Object.assign(object['inputs'], {'etat_civil': parseInt(value)})
            }

            if (setter === setComedec) {
                Object.assign(object['inputs'], {'comedec': parseInt(value)})
            }

            if (setter === setComedec2) {
                Object.assign(object['inputs'], {'nombre_comedec_2': parseInt(value)})
            }

            if (setter === setComedec1) {
                Object.assign(object['inputs'], {'nombre_comedec_1': parseInt(value)})
            }

            if (setter === setCopieAuthentique) {
                Object.assign(object['inputs'], {'nombre_copie_authentique': parseInt(value)})
            }

            if (setter === setCopieLibre) {
                Object.assign(object['inputs'], {'nombre_copie_libre': parseInt(value)})
            }

            if (setter === setArchivage) {
                Object.assign(object['inputs'], {'nombre_archivage': parseInt(value)})
            }

            if (setter === props.setConventionHonoraires) {
                if(value === 0){
                props.setNombreConventionHonoraires(1);
                props.setObjectConventionHonoraires(null);
                props.setMontantConventionHonoraires(null);
                props.setNomSignataireConventionHonoraires(null);
                props.setAdresseSignataireConventionHonoraires(null);
                Object.assign(
                    object["inputs"], { convention_honoraires : parseInt(value) },
                    object["pdfInputs"], {
                    nombre_convention_honoraires : null,
                    object_convention_honoraires : null,
                    montant_convention_honoraires : null,
                    nom_signataire_convention_honoraires : null,
                    adresse_signataire_convention_honoraires : null
                    },
                );
                } else {
                Object.assign(object["inputs"], { convention_honoraires : parseInt(value) });
                }
            }

            if (setter === props.setNombreConventionHonoraires) {
                Object.assign(object["pdfInputs"], { nombre_convention_honoraires : parseInt(value) });
            }

            if (setter === props.setObjectConventionHonoraires) {
                Object.assign(object["pdfInputs"], { object_convention_honoraires : value });
            }

            if (setter === props.setMontantConventionHonoraires) {
                Object.assign(object["pdfInputs"], { montant_convention_honoraires : parseInt(value)});
            }

            if (setter === props.setNomSignataireConventionHonoraires) {
                Object.assign(object["pdfInputs"], { nom_signataire_convention_honoraires : value });
            }

            if (setter === props.setAdresseSignataireConventionHonoraires) {
                Object.assign(object["pdfInputs"], { adresse_signataire_convention_honoraires : value });
            }

            dispatch(setSimulateurObject(object));

        } else {

            // process child simu

        }
    }

    return (
        <div style={styles.container}>
            <div className="cardSimulateur">
                <TextSimulateurTitle title={props.simulateur.name} currentSimuId={props.simulateur.id}/>

                <TextfieldRemarques handleChange={handleChangeRemarque}/>

                <p style={styles.cardSubTitle}>Acte tarifé au titre du Tableau 5, n° 35 (Art A444-79)</p>

                {props?.isParent === true && props.departements !== "" ?
                    <div className="cardRow">
                        <div style={styles.cardElemVerticalyCenter}>
                            Département :
                        </div>

                        <SelectDepartement items={props.departements} nameField={"name"} defaultValue={currUserDep} optionValue={"id"}
                                      handleChange={handleChange} setter={setDepartement}/>
                    </div>
                    :
                    <></>
                }

                <div className="cardRow">
                    <div style={styles.cardElemVerticalyCenter}>
                        Les pièces d’état-civil ont-elles été demandées ?
                    </div>
                    <ButtonYesno handleChange={handleChange} setter={setEtatCivil} defaultValue={0}/>
                </div>

                {
                parseInt(etat_civil) === 1 ?
                <div className="cardRow">
                    <div style={styles.cardElemVerticalyCenter}>
                        Avez-vous eu recours à Comedec ?
                    </div>
                    <ButtonYesno handleChange={handleChange} setter={setComedec} defaultValue={0}/>
                </div>
                :
                <></>
                }

                {
                parseInt(comedec) === 1 ?
                <div className="cardRow">
                    <div style={styles.cardElemVerticalyCenter}>
                        Indiquer le nombre de Comedec à 3,65€
                    </div>
                    <TextfieldNumber
                        handleChange={handleChange}
                        type={"number"}
                        placeholder={"Indiquer le nombre"}
                        setter={setComedec2}
                    />
                </div>
                :
                <></>
                }

                {
                parseInt(comedec) === 1 ?
                <div className="cardRow">
                    <div style={styles.cardElemVerticalyCenter}>
                        Indiquer le nombre de Comedec à 0,65€
                    </div>
                    <TextfieldNumber
                        handleChange={handleChange}
                        type={"number"}
                        placeholder={"Indiquer le nombre"}
                        setter={setComedec1}
                    />
                </div>
                :
                <></>
                }

                <div className="cardRow">
                    <div style={styles.cardElemVerticalyCenter}>
                        Nombre de page(s) « copie authentique » ?
                    </div>
                    <TextfieldNumber
                        handleChange={handleChange}
                        type={"number"}
                        placeholder={"Indiquer le nombre de pages"}
                        setter={setCopieAuthentique}
                    />
                </div>

                <div className="cardRow">
                    <div style={styles.cardElemVerticalyCenter}>
                        Nombre de page(s) « copie libre » ?
                    </div>
                    <TextfieldNumber
                        handleChange={handleChange}
                        type={"number"}
                        placeholder={"Indiquer le nombre de pages"}
                        setter={setCopieLibre}
                    />
                </div>

                <div className="cardRow">
                    <div style={styles.cardElemVerticalyCenter}>
                        Nombre de page(s) « archivage numérisé » ?
                    </div>
                    <TextfieldNumber
                        handleChange={handleChange}
                        type={"number"}
                        placeholder={"Indiquer le nombre de pages"}
                        setter={setArchivage}
                    />
                </div>

                <LcbFtQuestion
                    handleChange={handleChange}
                    setFormaliteArt204={setFormaliteArt204}
                />

                <DeboursQuestion
                    handleChange={handleChange}
                    deboursAdditionnels={deboursAdditionnels}
                    setDeboursAdditionnels={setDeboursAdditionnels}
                    setMontantDeboursAdditionnels={setMontantDeboursAdditionnels}
                />

                <ConventionHonoraires
                    handleChange={handleChange}
                    conventionHonoraires={props.conventionHonoraires}
                    setConventionHonoraires={props.setConventionHonoraires}
                    nombreConventionHonoraires={props.nombreConventionHonoraires}
                    setNombreConventionHonoraires={props.setNombreConventionHonoraires}
                    objectConventionHonoraires={props.objectConventionHonoraires}
                    setObjectConventionHonoraires={props.setObjectConventionHonoraires}
                    montantConventionHonoraires={props.montantConventionHonoraires}
                    setMontantConventionHonoraires={props.setMontantConventionHonoraires}
                    nomSignataireConventionHonoraires={props.nomSignataireConventionHonoraires}
                    setNomSignataireConventionHonoraires={props.setNomSignataireConventionHonoraires}
                    adresseSignataireConventionHonoraires={props.adresseSignataireConventionHonoraires}
                    setAdresseSignataireConventionHonoraires={props.setAdresseSignataireConventionHonoraires}
                />
            </div>

            </div>
        )
    }

export default Simulateur_ASF7;
